export const toUpperCaseWords = (str?: string) =>
  str?.replace(/\b[a-z]/g, (char, index) =>
    index === 0 || str[index - 1] === ' ' || str[index - 1] === '\t' || str[index - 1] === '\n'
      ? char.toUpperCase()
      : char,
  );
